/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from "react"
import { useParams } from "react-router-dom"

import styled from "styled-components"

import { spacing } from "@izettle/otto"
import { Loader, LoaderSize } from "@izettle/react"

import { ModalProvider } from "@/core/components/modal"
import { Page, Flex, Row, WallSuccess } from "@/core/components/shared"
import { useOptOutCustomer } from "@/modules/sign-up/api/use-opt-out-customer"
import { useSellerInfo } from "@/modules/sign-up/api/use-seller-info"
import { EmptyState } from "@/modules/sign-up/components/empty-state"
import { ErrorState } from "@/modules/sign-up/components/error-state"
import { PolicyModal } from "@/modules/sign-up/components/policy-modal"
import { Modals } from "@/modules/sign-up/components/types"

import { OptOutFooter } from "./optout-footer"
import { OptOutSuccessComponent } from "./optout-success"
import { OptOutWelcomeComponent } from "./optout-welcome"

const Container = styled(Page)`
  margin: ${spacing.medium};
  & > ${Flex} {
    max-width: 650px;
  }
  ${WallSuccess} {
    height: 30vh;
  }
  @media (max-width: 400px) {
    margin-top: ${spacing.xLarge};
    display: flex;
    align-items: flex-start;
    ${WallSuccess} {
      height: 50vh;
    }
  }
`

export const OptOutFromSellerPage = () => {
  const [hasOptOut, setHasOptOut] = useState(false)

  const { orgUuid, customerUuid } = useParams<{
    customerUuid: string
    orgUuid: string
  }>()

  if (!orgUuid || !customerUuid) {
    return <EmptyState />
  }

  const { isFetching: isFetchinSellerInfo, data: sellerInfoData } = useSellerInfo(orgUuid)

  const {
    orgName = "",
    orgLogoUrl,
    orgPhoneNumber,
    orgContactEmail,
    orgPrivacyPolicyLink,
  } = sellerInfoData ?? {}

  const {
    refetch: sendOptOutRequest,
    isFetching: isOptingOutFethcing,
    data: optingOutData,
  } = useOptOutCustomer(orgUuid, customerUuid, () => {
    setHasOptOut(true)
  })

  const modals = [
    <PolicyModal
      key={Modals.Policy}
      orgName={orgName}
      phone={orgPhoneNumber}
      email={orgContactEmail}
      linkToMerchantPrivacyPolicy={orgPrivacyPolicyLink}
    />,
  ]

  const handleOptOutClick = async () => {
    await sendOptOutRequest()
  }

  if (optingOutData?.failureMessage || sellerInfoData?.failureMessage) {
    return <ErrorState />
  }

  if (isFetchinSellerInfo) {
    return (
      <Page data-testid="loading">
        <Loader size={LoaderSize.Large} />
      </Page>
    )
  }

  return (
    <ModalProvider modals={modals}>
      <Container>
        <Flex>
          <Row>
            {!hasOptOut ? (
              <OptOutWelcomeComponent
                orgLogoUrl={orgLogoUrl}
                orgName={orgName}
                isOptingOutFethcing={isOptingOutFethcing}
                handleOptOutClick={handleOptOutClick}
              />
            ) : (
              <OptOutSuccessComponent orgName={orgName} />
            )}
            <OptOutFooter orgName={orgName} orgPrivacyPolicyLink={orgPrivacyPolicyLink} />
          </Row>
        </Flex>
      </Container>
    </ModalProvider>
  )
}
